import { ProductPageLayout } from '../components/ProductPageLayout';

export function KelasAiPage() {
    return <ProductPageLayout productId="kelas-ai" backTo="/" />;
}
